import { ReadonlyURLSearchParams } from 'next/navigation';

/**
 * Get the current state of showBuyerDetails from URL params
 */
export const getShowBuyerDetailsState = (
  params: ReadonlyURLSearchParams | null
): boolean => {
  return params?.get('showBuyerDetails') === 'true';
};

/**
 * Create a new URLSearchParams object with showBuyerDetails toggled
 */
export const toggleBuyerDetailsParam = (
  currentParams: ReadonlyURLSearchParams | null
): URLSearchParams => {
  const newParams = new URLSearchParams();
  
  // Copy existing params (use append to preserve multiple values for same key)
  currentParams?.forEach((value, key) => {
    if (key !== 'showBuyerDetails') {
      newParams.append(key, value);
    }
  });

  // Toggle showBuyerDetails
  const showBuyerDetails = getShowBuyerDetailsState(currentParams);
  if (!showBuyerDetails) {
    newParams.set('showBuyerDetails', 'true');
  }

  return newParams;
};

/**
 * Toggle the showBuyerDetails search param in the URL
 */
export const getBuyerDetailsPath = (
  currentParams: ReadonlyURLSearchParams | null,
  currentPath: string
): string => {
  const newParams = toggleBuyerDetailsParam(currentParams);
  return `${currentPath}?${newParams.toString()}`;
};
